"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSnowplowTracker = void 0;
const browser_plugin_ad_tracking_1 = require("@snowplow/browser-plugin-ad-tracking");
const browser_plugin_client_hints_1 = require("@snowplow/browser-plugin-client-hints");
const browser_plugin_link_click_tracking_1 = require("@snowplow/browser-plugin-link-click-tracking");
const browser_plugin_performance_timing_1 = require("@snowplow/browser-plugin-performance-timing");
const browser_tracker_1 = require("@snowplow/browser-tracker");
const url_1 = require("../url/url");
const cross_domain_linker_criterion_1 = require("./cross-domain-linker-criterion");
/**
 * Initialize the tracker
 * v.0.14.0;
 * @public
 *
 * @param config - SnowPlow configuration
 * @returns A Snowplow tracker
 *
 * @example
 * ```ts
 *
 * import { initSnowplowTracker, getHealthcareCollector } from '@hc-frontend/third-party-snowplow';
 *
 * initSnowplowTracker({
 *   appId: 'healthcare.com',
 *   collector: getHealthcareCollector({ isProd: true }),
 *   crossDomainLinkerCriterion: linkElement => linkElement.getAttribute("data-is-cross-domain") === "true"
 *   contexts: [{ schema: "iglu:com.healthcare/context_schema/jsonschema/1-0-0", data: { key: "value" } }]
 * });
 * ```
 */
function initSnowplowTracker({ isProd = false, plugins = [], crossDomainLinkerCriterion = cross_domain_linker_criterion_1.linksToHcDomainCriterion, contexts = [], }) {
    const currentPlugins = [
        (0, browser_plugin_link_click_tracking_1.LinkClickTrackingPlugin)(),
        (0, browser_plugin_performance_timing_1.PerformanceTimingPlugin)(),
        (0, browser_plugin_client_hints_1.ClientHintsPlugin)(),
        (0, browser_plugin_ad_tracking_1.AdTrackingPlugin)(),
    ];
    const appId = (0, url_1.getRootDomain)();
    const collector = (0, url_1.getCollector)(window.location.hostname, isProd);
    const tracker = (0, browser_tracker_1.newTracker)('sp', collector, {
        appId,
        discoverRootDomain: true,
        cookieSameSite: 'Lax',
        plugins: currentPlugins.concat(plugins),
    });
    (0, browser_plugin_link_click_tracking_1.enableLinkClickTracking)({ pseudoClicks: true, trackContent: true });
    if (crossDomainLinkerCriterion != null)
        (0, browser_tracker_1.crossDomainLinker)(crossDomainLinkerCriterion);
    if (contexts != null && contexts.length > 0)
        (0, browser_tracker_1.addGlobalContexts)(contexts);
    return { tracker: tracker, pageView: browser_tracker_1.trackPageView };
}
exports.initSnowplowTracker = initSnowplowTracker;
//# sourceMappingURL=snowplow.js.map